export const MODULE_REGISTRY_STATIC = [
  { code: "core_platform", name: "Core Platform", category: "Foundation" },
  { code: "patient_core", name: "Patient Core", category: "Clinical" },
  { code: "opd", name: "OPD", category: "Clinical" },
  { code: "emergency", name: "Emergency", category: "Clinical" },
  { code: "ipd", name: "IPD", category: "Clinical" },
  { code: "icu360", name: "ICU360", category: "Clinical" },
  { code: "billing", name: "Billing", category: "Financial" },
  { code: "pmjay", name: "PM-JAY", category: "Financial" },
  { code: "cashless_tpa", name: "Cashless / TPA", category: "Financial" },
  { code: "pharmacy", name: "Pharmacy", category: "Clinical" },
  { code: "laboratory", name: "Laboratory", category: "Diagnostics" },
  { code: "radiology", name: "Radiology", category: "Diagnostics" },
  { code: "ot", name: "OT", category: "Clinical" },
  { code: "hr_workforce", name: "HR & Workforce", category: "Operations" },
  { code: "duty_management", name: "Duty Management", category: "Operations" },
  { code: "command_centre", name: "Management Command Centre", category: "Intelligence" },
];

export const MODULE_LABELS = Object.fromEntries(MODULE_REGISTRY_STATIC.map((m) => [m.code, m.name]));
